import React, { useEffect, useState } from "react";
import CocoProfileUpdateForm from "../../components/CocoProfileUpdate";
import { getUrlParams } from "../../utils/utils";
import useConsentFragment from "../../hooks/useConsentFragment";

const ProfileUpdate = () => {
  const params = getUrlParams();
  const { getVersionInfo } = useConsentFragment();
  const [versionInfo, setVersionInfo] = useState();
  const getVersionDetails = async (obj) => {
    const { controller, scope, language } = obj;
    const data = await getVersionInfo(controller, scope, language);
    setVersionInfo(data);
  };
  useEffect(() => {
    const obj = {
      controller:
        params?.CountryCode?.toLowerCase() +
        "_" +
        params?.Division?.toLowerCase(),
      scope: "hcp",
      type: params?.SourceSystem?.toLowerCase(),
      value: params.CustomerID,
      language: params?.Language,
    };
    getVersionDetails(obj);
  }, []);
  return <CocoProfileUpdateForm values={params} versionInfo={versionInfo} />;
};

export default ProfileUpdate;
